import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'auction10';
export const selectAuction10State = state => state[STORE_KEY];
export const selectAuction10 = state => selectAuction10State(state).currentAuction10;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentAuction10: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_AUCTION10_REQUEST = `${STORE_KEY}/LOAD_AUCTION10_REQUEST`;
export const LOAD_AUCTION10_SUCCESS = `${STORE_KEY}/LOAD_AUCTION10_SUCCESS`;
export const LOAD_AUCTION10_ERROR = `${STORE_KEY}/LOAD_AUCTION10_ERROR`;

export const loadAuction10Request = payload => ({
  type: LOAD_AUCTION10_REQUEST,
  payload: { ...payload },
});
export const loadAuction10Success = ({ cheatsheet }, year, week, formulaId) => ({
  type: LOAD_AUCTION10_SUCCESS,
  payload: { cheatsheet, year, week, formulaId },
});
export const loadAuction10Error = error => ({
  type: LOAD_AUCTION10_ERROR,
  payload: { error },
});

actions[LOAD_AUCTION10_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_AUCTION10_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentAuction10: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_AUCTION10_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadAuction10 = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadAuction10Request(year, week, formulaId));
    const auction10 = await api.cheatSheets.getByWeekAuction10(year);

    return dispatch(loadAuction10Success(auction10, year, week, formulaId));
  } catch (error) {
    console.error(error);
    return dispatch(loadAuction10Error(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const AUCTION10_VIEW = `${STORE_KEY}/AUCTION10_VIEW`;

viewNames[AUCTION10_VIEW] = 'Auction10';
routes[AUCTION10_VIEW] = {
  path: '/fantasy-football-rankings-cheat-sheets/:year/auction-10-team',
  thunk: async (dispatch, getState) => {
    const state = getState();

    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadAuction10(year, week, formulaId));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Auction10/module/auction10.js